<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con red">{{ dataItem.createdate }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">取件类型：</p>
            <p class="con">
              {{ dataItem.get_sitein == 2 ? "园区外" : "园区内" }}
            </p>
          </div>
          <div class="column flex-rowl" v-if="dataItem.get_sitein == 2">
            <p class="label">取件地址：</p>
            <p class="con">
              {{ dataItem.province }}{{ dataItem.city }}{{ dataItem.area }}
              {{ dataItem.address }}
            </p>
          </div>
          <div class="column flex-rowl" v-else>
            <p class="label">取件地址：</p>
            <p class="con">
              {{ dataItem.getyuanqu }}{{ dataItem.get_parameteridstr
              }}{{ dataItem.get_buildingidstr }}{{ dataItem.get_addr }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取件人信息：</p>
            <p class="con">{{ dataItem.get_truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取件人手机号：</p>
            <p class="con">{{ dataItem.getlinkphone }}</p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">送件地址：</p>
            <p class="con">
              {{ dataItem.takeyuanqu }}{{ dataItem.take_parameteridstr
              }}{{ dataItem.take_buildingidstr }}
            </p>
            
          </div>
          <div class="column flex-rowl">
            <p class="label">送件人信息：</p>
            <p class="con">{{ dataItem.give_truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送件人手机号：</p>
            <p class="con">{{ dataItem.givelinkphone }}</p>
          </div>
        </div>

        <div class="block_two">
          <div class="column">
            <p class="label tit">物件信息</p>
            <p class="label">重量：{{ dataItem.weight }}</p>
          </div>
          <div class="column column_img flex-rowl">
            <div
              class="cloumn_item"
              v-for="(item, index) in dataItem.givepicArr"
              :key="index"
              @click="handlePreview(index)"
            >
              <van-image width="100%" height="100" :src="item" />
            </div>
          </div>
          <!-- <div class="column">
            <p class="label">备注：{{ dataItem.ordernote }}</p>
          </div> -->
        </div>

        <div class="block_two">备注： {{ dataItem.ordernote }}</div>
        <div class="block_two">
          <div class="column">
            <p class="label">
              服务进度：
              {{ dataItem.server_statestr }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <div
              class="custom_btn flex-rowc"
              :class="{ disabled: dataItem.server_state >= 2 }"
              @click="handleStatus(1)"
            >
              已取件
            </div>
            <div
              class="custom_btn flex-rowc"
              :class="{ disabled: dataItem.msg_iserr == 1 }"
              @click="handleStatus(4)"
            >
              物品信息不符
            </div>
          </div>
          <div class="column flex-rowl">
            <div
              class="custom_btn flex-rowc"
              :class="{ disabled: dataItem.server_state >= 3 }"
              @click="handleStatus(2)"
            >
              开始送件
            </div>
          </div>
          <div class="column flex-rowl">
            <div
              class="custom_btn flex-rowc"
              :class="{ disabled: dataItem.server_state >= 4 }"
              @click="handleStatus(3)"
            >
              确认送达
            </div>
          </div>
          <div class="column flex-rowl">
            <div class="custom_btn flex-rowc">
              <a :href="'tel:' + dispatchManageTel">联系派单管理员</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom_btn flex-rowc" @click="handleReturn">返回</div>

    <van-image-preview
      v-model="isImggeShow"
      :images="dataItem.givepicArr"
      :startPosition="startPosition"
    >
    </van-image-preview>

    <!--  -->
    <van-overlay :show="isShow" :lock-scroll="false" z-index="100001">
      <div class="custom_popup">
        <div class="custom_close flex-rowc" @click="isShow = false">
          <span class="iconfont icon-jujueweituo"></span>
        </div>
        <div class="custom_popup_wrap">
          <h1 class="flex-rowc">物品信息不符描述</h1>
          <div class="custom_popup_main">
            <p>订单异常类型</p>
            <div class="radio_wrap mb">
              <van-radio-group
                v-model="abnormalParams.errtype"
                direction="horizontal"
              >
                <van-radio name="1">超重</van-radio>
                <van-radio name="2">数量不符</van-radio>
                <van-radio name="3">物品类型不符</van-radio>
                <van-radio name="4">联系不到取件人</van-radio>
                <van-radio name="5">联系不到收件人</van-radio>
                <van-radio name="6">其他</van-radio>
              </van-radio-group>
            </div>
            <div class="input_block" v-if="abnormalParams.errtype == 1">
              <p>实际重量评估为：</p>
              <div class="input_wrap flex-rowl">
                <div class="input_box">
                  <van-field v-model="abnormalParams.realweight" />
                </div>
                <p class="unit">Kg</p>
              </div>
            </div>
            <div class="input_block" v-if="abnormalParams.errtype == 2">
              <p>实际数量评估为：</p>
              <div class="input_wrap flex-rowl">
                <div class="input_box">
                  <van-field v-model="abnormalParams.diff_num" />
                </div>
                <p class="unit">件</p>
              </div>
            </div>
            <div class="radio_block" v-if="abnormalParams.errtype == 3">
              <p>物品种类不符情况：</p>
              <div class="radio_wrap">
                <van-radio-group
                  v-model="abnormalParams.kinddiff"
                  direction="horizontal"
                >
                  <van-radio name="1">易燃易爆</van-radio>
                  <van-radio name="2">活体动物</van-radio>
                  <van-radio name="3">易碎或其他安全隐患</van-radio>
                  <van-radio name="4">管制器材</van-radio>
                  <van-radio name="5">不符合园区安全规定的其他种类</van-radio>
                </van-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div class="custom_popup_footer flex-rowc">
          <div class="custom_btn" @click="handleSubmitAbnormal">提交</div>
        </div>
      </div>
    </van-overlay>

    <!-- 送达取件码 -->
    <van-overlay :show="isPickUpShow" :lock-scroll="false" z-index="100001">
      <div class="custom_popup">
        <div class="custom_close flex-rowc" @click="isPickUpShow = false">
          <span class="iconfont icon-jujueweituo"></span>
        </div>
        <div class="custom_popup_wrap">
          <h1 class="flex-rowc">
            输入4位数收件（送达）确认码 <br />请向收件人询问获取
          </h1>
          <div class="custom_popup_main">
            <div class="input_box">
              <van-field
                type="number"
                maxlength="4"
                v-model="pick_code"
                @keyup.enter="handleSubmit"
              />
            </div>
          </div>
        </div>
        <div class="custom_popup_footer flex-rowc">
          <div class="custom_btn" @click="handleSubmit">确认</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
  
<script>
import {
  getParkOrderDetail,
  getToken,
  submitAbnormal,
  getPickUp,
  getDelivery,
  getDeliverySuccess,
} from "../../api/api";
export default {
  name: "pMineDetail",
  data() {
    return {
      isImggeShow: false,
      startPosition: 0,
      isShow: false,
      isPickUpShow: false,
      popupSrc: "",
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      order_id: "", // 订单id
      token: "", // token

      // 投诉原因
      complaint_reason: [
        "接送件等待时间过长",
        "长时间无人接单",
        "跑腿人员态度较差",
        "物品损坏",
        "其他",
      ],
      // 订单异常
      abnormalParams: {
        token: "",
        order_id: "",
        msg_iserr: 1, // 订单信息是否异常 =0=否 1=是
        errtype: "", // 订单异常类型 =0=无 1=超重 2=数量不符 3=物品类型不符 4=联系不到取件人 5=联系不到收件人 6=其他
        realweight: "",
        diff_num: "",
        kinddiff: "", // 物品种类不符情况 =1=易燃易爆 2=活体动物 3=易碎或其他安全隐患 4=管制器材 5=不符合园区安全规定的其他种类
      },
      goodNum: "",
      // 投诉参数
      complainParams: {
        token: "",
        order_id: "",
        has_complaint: "",
        complaint_reason: "",
        complaint_reason_note: "",
        complaint_deal: "",
        complaint_talk: "",
        complaint_status: "",
        complaint_dealstatus: "",
      },

      pick_code: "", // 收件码
      dispatchManageTel: "", // 派单管理员电话
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    // this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(type) {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.token = res.data.token;
          if (type == "getPickUp") {
            this.getPickUp();
          } else if (type == "getDelivery") {
            this.getDelivery();
          } else if (type == "getDeliverySuccess") {
            this.getDeliverySuccess();
          } else if (type == "submitAbnormal") {
            this.submitAbnormal();
          } else {
            this.getParkOrderDetail(res.data.token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 查看跑腿订单详情
    getParkOrderDetail(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getParkOrderDetail({ order_id, token }).then((res) => {
        res.get_list.forEach((v) => {
          if (v.isdel == 0) {
            this.dispatchManageTel = v.get_staff_contact;
          }
        });
        this.dataItem = res;
        res.givepicArr = res.givepic ? res.givepic.split(",") : [];
        this.isLoading = false;
        toast.clear();
      });
    },
    // 取件
    getPickUp() {
      let { order_id, token, dataItem } = this;
      let params = {
        token,
        order_id,
        delivery_staff_id: dataItem.reci_openid,
      };
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getPickUp(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          this.getParkOrderDetail(token);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 开始送件
    getDelivery() {
      let { order_id, token, dataItem } = this;
      let params = {
        token,
        order_id,
        delivery_staff_id: dataItem.reci_openid,
      };
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getDelivery(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          this.getParkOrderDetail(token);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 异常处理
    submitAbnormal() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { order_id, token } = this;
      this.abnormalParams.order_id = order_id;
      this.abnormalParams.token = token;
      submitAbnormal(this.abnormalParams).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          this.getParkOrderDetail(token);
          this.isShow = false;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 确认送达
    getDeliverySuccess() {
      let { order_id, token, dataItem, pick_code } = this;
      let params = {
        token,
        order_id,
        delivery_staff_id: dataItem.reci_openid,
        pick_code,
      };
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getDeliverySuccess(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          this.isPickUpShow = false;
          this.getParkOrderDetail(token);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 上报异常
    handleSubmitAbnormal() {
      let { abnormalParams } = this;
      if (abnormalParams.errtype == "") {
        this.$toast("请选择订单异常类型");
        return;
      }
      if (abnormalParams.errtype == 1 && abnormalParams.realweight == "") {
        this.$toast("请输入物品实际重量");
        return;
      }
      if (abnormalParams.errtype == 2 && abnormalParams.diff_num == "") {
        this.$toast("请输入订单异常差额核算");
        return;
      }
      if (abnormalParams.errtype == 3 && abnormalParams.kinddiff == "") {
        this.$toast("请选择物品种类不符情况");
        return;
      }
      this.getToken("submitAbnormal");
    },

    // 服务进度
    handleStatus(type) {
      // type 1-取件 2-送件
      let { dataItem } = this;
      if (type == 1) {
        if (dataItem.server_state >= 2) return;
        this.$dialog
          .confirm({
            // title: "标题",
            message: "是否确认取件",
          })
          .then(() => {
            // on confirm
            this.getToken("getPickUp");
          })
          .catch(() => {
            // on cancel
          });
      } else if (type == 2) {
        if (dataItem.server_state >= 3) return;
        this.$dialog
          .confirm({
            // title: "标题",
            message: "是否确认开始送件",
          })
          .then(() => {
            // on confirm
            this.getToken("getDelivery");
          })
          .catch(() => {
            // on cancel
          });
      } else if (type == 3) {
        if (dataItem.server_state >= 4) return;
        this.isPickUpShow = true;
      } else if (type == 4) {
        if (dataItem.msg_iserr == 1) return;
        this.isShow = true;
      }
    },

    // 确认送达
    handleSubmit() {
      let { pick_code } = this;
      if (pick_code == "") {
        this.$toast("请输入确认码");
        return;
      }
      this.getToken("getDeliverySuccess");
    },

    handleReturn() {
      this.$router.back();
    },

    // 预览图片
    handlePreview(index) {
      this.isImggeShow = true;
      this.startPosition = index;
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding: 40px 0 300px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .con {
        &.red {
          color: #ff0000;
        }
      }
      .block_one {
        font-size: 30px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
        }
      }
      .block_two {
        margin-bottom: 65px;
        .custom_btn {
          width: 240px;
          margin: 0 20px 0 0;
          a {
            width: 100%;
            height: 100%;
            color: #fff;
            display: inline-block;
          }
          &.disabled {
            background: #9e9e9e;
          }
        }
      }
      .column_img {
        flex-wrap: wrap;
        .cloumn_item {
          width: calc((100% - 60px) / 3);
          &:nth-child(3n-1) {
            margin: 0 30px;
          }
        }
      }
      .btn {
        margin-bottom: 60px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          min-width: 190px;
          flex-shrink: 0;
          &.tit {
            margin-bottom: 10px;
          }
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
        .select_box {
          margin-top: 20px;
          width: 100%;
          flex-shrink: 0;
          p {
            flex: 1;
          }
          .iconfont {
            font-size: 38px;
          }
        }
      }
      .column_btn_group {
        margin-top: 30px;
        .custom_btn {
          width: 240px;
        }
      }
    }
  }
  .custom_btn {
    &.isDisabled {
      background: #979797;
    }
  }
  .van-radio {
    margin-bottom: 10px;
  }
  .custom_popup {
    width: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    background: #ffffff;
    padding: 60px 0 50px;
    .custom_close {
      position: fixed;
      right: 0;
      top: -70px;
      .iconfont {
        font-size: 52px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .custom_popup_wrap {
      h1 {
        font-size: 34px;
        box-sizing: border-box;
      }
      .custom_popup_main {
        min-height: 20vh;
        max-height: 39vh;
        overflow-y: scroll;
        font-size: 26px;
        padding: 0 30px;
        box-sizing: border-box;
        margin: 50px 0 100px;
        p {
          margin-bottom: 20px;
          font-size: 28px;
        }
        .mb {
          margin-bottom: 40px;
        }
        .unit {
          margin-left: 20px;
          margin-bottom: 0;
        }
      }
      .custom_popup_footer {
        // height: 130px;
      }
    }
  }
}
</style>